import _ from 'lodash'
import { getJobDetail, saveJobActivity, saveJobApplication, updateJobApplicationUserStatus as putJobApplicationUserStatus, loadJobApplication, loadJobApplications, getAllEntityIdsWithRecommendation, getRecommendationForEntity, getLibraryPositionMapping } from '../api'
import { getResults } from '../../search/api'
import { getLibrariesForUser } from '../../dashboard/api'
import { getBaseQuery } from '../../search/searchUtils'

var getJobBaseQuery = function (privateLibraryList, publicLibraryList, loggedInUserUUID) {
  return getBaseQuery(privateLibraryList || [], publicLibraryList || [], loggedInUserUUID, [])
}

var getGeoDistanceFilters = function (filterObj) {
  let geoFilters = []
  if (!filterObj || !filterObj.bool || !Array.isArray(filterObj.bool.must)) {
    return geoFilters
  }
  filterObj.bool.must.forEach((clause) => {
    if (clause && clause.geo_distance) {
      geoFilters.push(clause)
    }
  })
  return geoFilters
}

var addFilterToBoolQuery = function (boolQuery, clause) {
  if (!boolQuery) {
    return
  }
  if (!boolQuery.filter) {
    boolQuery.filter = [clause]
    return
  }
  if (Array.isArray(boolQuery.filter)) {
    boolQuery.filter.push(clause)
    return
  }
  boolQuery.filter = [boolQuery.filter, clause]
}

var addGeoDistanceFiltersToQuery = function (buildQuery, geoFilters) {
  if (!buildQuery || !geoFilters || geoFilters.length === 0) {
    return
  }
  geoFilters.forEach((geoFilter) => {
    if (buildQuery.constant_score && buildQuery.constant_score.filter && buildQuery.constant_score.filter.bool) {
      addFilterToBoolQuery(buildQuery.constant_score.filter.bool, geoFilter)
    } else if (buildQuery.bool) {
      addFilterToBoolQuery(buildQuery.bool, geoFilter)
    }
  })
}

export const loadJobDetail = ({ state, commit }, uuid) => {
  return getJobDetail(uuid).then(data => {
    if (data !== undefined) {
      commit('LOAD_JOB', data)
    }
    return data
  })
}

export const addJobActivity = ({ state, commit }, jobActivity) => {
  return saveJobActivity(jobActivity)
}

export const addJobApplication = ({ state, commit }, jobApplication) => {
  return saveJobApplication(jobApplication)
}

export const updateJobApplicationUserStatus = ({ state, commit }, {applicationId, status}) => {
  return putJobApplicationUserStatus(applicationId, status)
}

export const getJobApplication = ({ state, commit }, jobId) => {
  return loadJobApplication(jobId)
}

export const getJobApplications = ({ state, commit }) => {
  return loadJobApplications()
}

export const loadAllJobIdsWithRecommendation = ({ state, commit }) => {
  return getAllEntityIdsWithRecommendation('job')
}

export const loadRecommendationForEntity = ({ state, commit }, entityUuid) => {
  return getRecommendationForEntity(entityUuid)
}

export const loadJobLibraryPositionMapping = ({ state, commit }) => {
  if (_.isEmpty(state.libraryPositionMapping)) {
    return getLibraryPositionMapping().then(mapping => {
      commit('LOAD_JOB_LIBRARY_POSITION_MAPPING', mapping || {})
      return mapping
    })
  }
  return Promise.resolve(state.libraryPositionMapping)
}

export const loadAllLibraryForUser = ({ state, commit }, userId) => {
  return getLibrariesForUser(userId).then(libraries => {
    return libraries || []
  })
}

export const updateJobFrom = ({ state, commit }, from) => {
  commit('LOAD_JOB_SEARCH_FROM', from)
}

export const updateJobPageNumber = ({ state, commit }, pageNumber) => {
  commit('LOAD_JOB_SEARCH_PAGE_NUMBER', pageNumber)
}

export const updateJobSize = ({ state, commit }, size) => {
  commit('LOAD_JOB_SEARCH_SIZE', size)
}

export const storeJobSelectedFacets = ({ state, commit }, data) => {
  commit('UPDATE_JOB_SELECTED_FACETS', data)
}

export const constructJobSearchQuery = ({ state, commit }, {terms, sort, source, from, size, indexList, libraryList, privateLibraryList, publicLibraryList, userId, aggs, filter, preserveSort}) => {
  if (terms !== undefined) {
    commit('LOAD_JOB_SEARCH_TERMS', terms)
  }
  if (from !== undefined) {
    commit('LOAD_JOB_SEARCH_FROM', from)
  }
  if (size !== undefined) {
    commit('LOAD_JOB_SEARCH_SIZE', size)
  }

  let buildQuery
  if (state.terms) {
    let queryString = {
      'query_string': {
        'fields': ['these_are_now_substituted_on_server_side'],
        'default_operator': 'OR',
        'allow_leading_wildcard': false,
        'query': 'TBA'
      }
    }
    queryString.query_string.query = state.terms
    buildQuery = getJobBaseQuery(privateLibraryList || [], publicLibraryList || [], userId)
    buildQuery.bool.must.push(queryString)
    if (!preserveSort) {
      sort = [{'_score': {'order': 'desc'}}]
    }
  } else {
    buildQuery = {
      'constant_score': {
        'filter': getJobBaseQuery(privateLibraryList || [], publicLibraryList || [], userId),
        'boost': 1.0
      }
    }
    let filterCopy = _.cloneDeep(filter)
    if (filterCopy && filterCopy.bool) {
      filterCopy.bool.must = []
      buildQuery.constant_score.filter.bool['filter'] = [filterCopy]
    }
    if (sort === undefined) {
      sort = [{lastUpdatedTime: {order: 'desc'}}]
    }
  }

  addGeoDistanceFiltersToQuery(buildQuery, getGeoDistanceFilters(filter))
  commit('LOAD_JOB_SEARCH_SORT', sort)

  var payload = {
    sort: sort,
    _source: source,
    from: from !== undefined ? from : state.from,
    size: size !== undefined ? size : state.size,
    query: buildQuery,
    aggs: aggs,
    track_total_hits: true,
    post_filter: filter
  }

  var requestPayload = {
    'indexList': indexList,
    'libraryList': libraryList,
    'payload': payload
  }

  return loadJobSearchResults({ state, commit }, requestPayload)
}

export const loadJobSearchResults = ({ state, commit }, data) => {
  if (!data || data.indexList === undefined || data.libraryList === undefined) {
    return {}
  }
  return getResults(data).then((res) => {
    let hits = (res && res.hits && res.hits.hits) ? res.hits.hits : []
    let totalRaw = res && res.hits ? res.hits.total : 0
    let total = 0
    if (typeof totalRaw === 'number') {
      total = totalRaw
    } else if (totalRaw && typeof totalRaw.value === 'number') {
      total = totalRaw.value
    }
    let processedHits = []
    for (var i = 0; i < hits.length; i++) {
      let source = hits[i]._source || {}
      processedHits.push({
        index: hits[i]._index,
        resourceType: hits[i]._index,
        type: source.type,
        title: source.title,
        employer: source.employer,
        employerUuid: source.employerUuid,
        salaryRange: source.salaryRange,
        minSalary: source.minSalary,
        maxSalary: source.maxSalary,
        contactInfo: source.contactInfo,
        jobTypes: source.jobTypes,
        description: source.description,
        uuid: source.uuid,
        creationTime: source.creationTime,
        postedDate: source.postedDate,
        applyBy: source.applyBy,
        viewCount: source.viewCount,
        applicantCount: source.applicantCount,
        lastUpdatedTime: source.lastUpdatedTime,
        thumbnailURI: source.thumbnailURI,
        thumbnail: source.thumbnail,
        uri: source.uri,
        appliedTagMap: source.appliedTagMap,
        aggregatedAppliedTags: source.aggregatedAppliedTags,
        originUuid: source.originUuid,
        careerCompetenciesMap: source.careerCompetenciesMap,
        careerCompetenciesList: source.careerCompetenciesList,
        ownerId: source.ownerId,
        ownerName: source.ownerName,
        geoLocation: source.geoLocation
      })
    }
    commit('LOAD_JOB_SEARCH_TOTAL', total)
    commit('LOAD_JOB_SEARCH_RESULTS', processedHits)
    commit('LOAD_JOB_SEARCH_AGGREGATIONS', (res && res.aggregations) || {})
    return res
  })
}



// WEBPACK FOOTER //
// ./src/app/job/vuex/actions.js